export const setUser = (data) => ({
	type: 'LOGIN',
	data,
});
export const setProfile = (data) => ({
	type: 'SETPROFILE',
	data,
});
